import { ChakraTheme } from "@chakra-ui/react";

const standardFontFamilies = `Source Sans Pro, inter -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`;

const fonts = {
  heading: standardFontFamilies,
  body: standardFontFamilies,
  mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`,
};

const fontSizes = {
  tiny: "0.625rem", // 10
  xs: "0.75rem", // 12
  sm: "0.875rem", // 14
  md: "1rem", // 16
  lg: "1.125rem", // 18
  xl: "1.25rem", // 20
  "2xl": "1.5rem", // 24
  "3xl": "1.875rem", // 30
  "4xl": "2rem", // 32
  "5xl": "3rem", // 48
  "6xl": "3.75rem",
  "7xl": "4.5rem",
  "8xl": "6rem",
  "9xl": "8rem",
};

const letterSpacings = {
  tightest: "-0.02em", // -0.96px
  tighter: "-0.01em", // -0.48px
  tight: "-0.005em", // -0.24px
  normal: "0",
  wide: "0.005em", // 0.24px
  wider: "0.01em", // 0.48px
  widest: "0.02em", // 0.96px
};

const fontWeights = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
};

const lineHeights = {
  normal: "normal",
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: "2",
  "3": ".75rem", // 12
  "4": "1rem", // 16
  "5": "1.25rem", // 20
  "5.5": "1.375rem", // 20
  "6": "1.5rem", // 24
  "6.5": "1.625rem", // 26
  "7": "1.75rem", // 28
  "8": "2rem", // 32
  "9": "2.25rem",
  "10": "2.5rem", // 40
  "11": "2.75rem",
  "12": "3.0rem",
  "13": "3.25rem",
  "14": "3.5rem", // 48
};

const typography: Partial<ChakraTheme> = {
  fonts,
  fontSizes,
  lineHeights,
  letterSpacings,
  fontWeights,
};

export default typography;
